module.exports = __webpack_public_path__ + "assets/qingrenjie.dd4fafb2.svg";